import { useForm } from 'react-hook-form';

import { Card, DateRangePicker, FormControl, FormItem, LoadingButton, Modal } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { endOfDay, startOfDay } from '~src/utils/date';
import { CalendarDateRange } from '~src/utils/date-schema';
import { time, toLocalCalendarDateTime, today } from '~src/utils/internationalized-date';

export interface FormValues {
  createdAtRange: CalendarDateRange;
}

interface Props {
  onSubmit: (payload: FormValues) => void;
  setIsOpen: (isOpen: boolean) => void;
  isOpen?: boolean;
}

export function BulkExportDialog(props: Props) {
  const { isOpen, onSubmit, setIsOpen } = props;

  const { t, i18n } = useTranslation();

  const { handleSubmit, setValue, watch } = useForm<FormValues>({
    defaultValues: {
      createdAtRange: {
        start: startOfDay(new Date()).toISOString(),
        end: endOfDay(new Date()).toISOString(),
      },
    },
  });

  return (
    <FormControl.Root>
      <Modal.Root open={isOpen} onOpenChange={setIsOpen}>
        <FormControl.Form onSubmit={handleSubmit(onSubmit)} style={{ display: 'none' }} />

        <Modal.Content>
          <Modal.Header title={t('common.exportCsv')} />

          <Modal.Body>
            <Card.List css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)' }}>
              <FormItem.Root css={{ gridColumn: 'span 12' }}>
                <FormItem.Label>{t('common.createdAt')}</FormItem.Label>
                <FormItem.Control>
                  <DateRangePicker
                    defaultTime={{ start: time(0, 0), end: time(23, 59) }}
                    placeholder={t('shipments.list.selectDateOrDateRange')}
                    locale={i18n.resolvedLanguage}
                    today={today('UTC')}
                    granularity="minute"
                    onChange={v =>
                      v &&
                      setValue('createdAtRange', {
                        start: v.start.toString(),
                        end: v.end.toString(),
                      })
                    }
                    value={{
                      start: toLocalCalendarDateTime(watch('createdAtRange').start),
                      end: toLocalCalendarDateTime(watch('createdAtRange').end),
                    }}
                  />
                </FormItem.Control>
              </FormItem.Root>
            </Card.List>
          </Modal.Body>
          <Modal.Footer>
            <FormControl.SubmitButton asChild>
              <LoadingButton variant="primary">{t('common.export')}</LoadingButton>
            </FormControl.SubmitButton>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </FormControl.Root>
  );
}
